export const DEFAULT_ROUTE = '/organizations'
